/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Select, SelectOption, FlexCol } from 'sarsaparilla';

export default function YearSelectFilter({ setOnChange, setValue }) {
    function handleChange(e) {
        setOnChange(e.target.value);
    }

    return (
        <FlexCol xs={12} md="variable" className="mr-0 mr-md-1 mr-lg-2 mb-2 mb-md-0">
            <Select
                id="contest-year"
                label="Contest Year"
                defaultValue="All"
                isLabelVisible={false}
                onChange={handleChange}
                value={setValue}
            >
                <SelectOption value="All">All Contest Years</SelectOption>
                <SelectOption value="2023">2023 Contest</SelectOption>
                <SelectOption value="2022">2022 Contest</SelectOption>
                <SelectOption value="2021">2021 Contest</SelectOption>
            </Select>
        </FlexCol>
    );
}

YearSelectFilter.propTypes = {
    setOnChange: PropTypes.func,
    setValue: PropTypes.string,
};
